import {createGrid} from "../../helpers/grids/grids";
import {loading} from "../../helpers/loading";
import createElement from "../../helpers/createElement";
import {
	createCellRenderer,
	createDoubleClickHandler,
	createTruncatedTextCellRenderer
} from "../../helpers/grids/helpers";

function initAgentsVoeOrdersIndex() {
	// noinspection JSUnresolvedVariable,DuplicatedCode
	createGrid('.orders-grid', {
			columnDefs: [
				{
					field: "public_id",
					headerName: 'Order Id',
					tooltipField: 'public_id',
					cellRenderer: createTruncatedTextCellRenderer(10,true),
				},
				{
					field: "assigned_to_user_at",
					headerName: 'Assigned At',
					sortable: true,
				},
				{
					field: "timeInQueue",
					headerName: 'Total Time',
					sortable: true,
				},
				{
					field: "public_id",
					headerName: '',
					cellRenderer: createCellRenderer(params => {
						// noinspection JSUnresolvedVariable
						const processUrl = params.data.processUrl;
						return createElement(`
							<div class="buttons">
                                <a class="btn btn-primary btn-sm" href="${processUrl}">
                                    <i class="fa-solid fa-file-import"></i>
                                    Process Order
								</a>
                            </div>
						`)
					})
				},
			],

			onRowDoubleClicked: createDoubleClickHandler(data => {
				loading();
				// noinspection JSUnresolvedVariable
				window.location.href = data.processUrl
			}),

			rowClass: 'cursor-pointer',
			paginationPageSize: 20,
			_rowName: 'Orders',
			_autoRefresh: true,
		},
		window['routes/agent.voe-orders.pending.grid']
	);
}

export {initAgentsVoeOrdersIndex}
